import { render } from "./CandidateCard.vue?vue&type=template&id=273ffb70&scoped=true"
import script from "./CandidateCard.vue?vue&type=script&lang=js"
export * from "./CandidateCard.vue?vue&type=script&lang=js"

import "./CandidateCard.vue?vue&type=style&index=0&id=273ffb70&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273ffb70"]])

export default __exports__